import styled from "styled-components"

export const LandingWrapp = styled.section`
  margin-top: 64px;

  .background-color {
    background: #f7f5f0;
    border-bottom: 1px solid #e7e2d8;
  }
  
  .landing {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 56px;
    min-height: 470px;
    padding: 64px 0 56px;

    @media (max-width: 1050px) {
      padding: 48px 0 40px;
      flex-direction: column;
      align-items: flex-start;
    }
    .left {
      flex: 1;
      .content {
        .title {
          margin-bottom: 16px;
          max-width: 560px;
          font-weight: 700;
          font-size: 4rem;
          line-height: 1.08;
          letter-spacing: 0;
          color: #17201b;
          span {
            color: #5f7967;
          }

          @media (max-width: 761px) {
            font-size: 3.2rem;
          }
        }
        .desc {
          max-width: 500px;
          font-size: 15px;
          color: #5f6670;
        }
        .section {
          display: flex;
          margin-top: 28px;

          .link-btn {
            color: white;
            font-weight: 700;
            letter-spacing: 0;
          }

          button {
            min-width: 150px;
            height: 42px;
            background: #28342f;
            box-shadow: none;
            border-radius: 8px;
            border: none;
            color: white;
            cursor: pointer;
            transition: background 0.2s ease, transform 0.2s ease;

            &:hover {
              background: #5f7967;
              transform: translateY(-1px);
            }
          }

          .info {
            h1 {
              text-align: center;
              font-weight: 700;
            }
          }
        }
      }
    }
    .right {
      flex: 0 0 340px;
      justify-content: flex-end;
      .background-image {
        width: 100%;
        .image {
          display: flex;
          justify-content: flex-end;

          img {
            width: min(320px, 80vw);
            filter: saturate(0.78);
          }
        }
      }

      @media (max-width: 1050px) {
        flex: none;
        width: 100%;

        .background-image .image {
          justify-content: flex-start;
        }
      }
    }
  }
`
